

require('./styles');

var _squid = require('squid');

var _index = require('xo-device-info/dist/index');

define(['squid/index', 'text!./template.html', '../cart/directive', 'xo-ui-components/src/escape-hatch/closeFrame/directive', 'xo-form-components/src/language-options/directive'], function (squid, template) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-header.directive', ['squid', 'xo-cart.directive', 'xo-escape-hatch.closeFrame.directive', 'xo-language-options.directive']).directive('xoHeader', function () {
        return {
            template: template,
            scope: {
                showCartTotal: '=',
                renderCartContainer: '=',
                token: '=',
                isUnbranded: '=',
                unbrandedTitle: '=',
                unbrandedSubTitle: '=',
                languageSwitch: '=?',
                redirectiframe: '=',
                redirectLightbox: '=',
                isVenmoFlow: '='
            },
            controller: function controller($scope, $rootScope, $renderContent, $SetHeaderText) {
                $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
                $scope.isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
                // $util.assert($scope.token, 'Expected token');
                $scope.title = $renderContent($scope.unbrandedTitle);
                $scope.subTitle = $renderContent($scope.unbrandedSubTitle);

                $SetHeaderText.subscribe($scope, function (event, text) {
                    $scope.unbrandedTitle = text;
                    $scope.title = $renderContent($scope.unbrandedTitle);
                });
            }
        };
    }).factory('$SetHeaderText', function ($rootScope) {
        var headerText = '';

        return {
            setText: function setText(text) {
                headerText = text;
                $rootScope.$emit('update_header_text', text);
            },
            getText: function getText() {
                return headerText;
            },
            subscribe: function subscribe($scope, callback) {
                var handler = $rootScope.$on('update_header_text', callback);
                $scope.$on('$destroy', handler);
            }
        };
    });
});
_squid.$integration;

_index.$DeviceInfo;


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/header/directive.js
// module id = ./components/xo-page-components/src/header/directive.js
// module chunks = 1